import api from './Api';

const base = '/api/v1/customer/orders';
export const orderApi = {
    quote: body => api.post('/api/v1/customer/checkout/quote', body),
    current: () => api.get('/api/v1/customer/checkout/current'),
    place: body => api.post(base, body),
    list: (page = 1) => api.get(base, {params:{page}}),
    recover: key => api.post(`${base}/recover`, {idempotency_key:key}),
    detail: number => api.get(`${base}/${encodeURIComponent(number)}`),
    payment: number => api.post(`${base}/${encodeURIComponent(number)}/payment`, {}),
    verify: (number, body) => api.post(`${base}/${encodeURIComponent(number)}/verify`, body),
    cancel: (number, body) => api.post(`${base}/${encodeURIComponent(number)}/cancel`, body),
    returnRequest: (number, body) => api.post(`${base}/${encodeURIComponent(number)}/returns`, body),
    creditNotes: number => api.get(`${base}/${encodeURIComponent(number)}/credit-notes`),
    invoice: number => api.get(`${base}/${encodeURIComponent(number)}/invoice`),
};

export const newRequestKey = () => window.crypto?.randomUUID?.() || `${Date.now()}-${Math.random().toString(36).slice(2)}-${Math.random().toString(36).slice(2)}`;
export const errorMessage = error => {
    const body = error?.response?.data;
    return Object.values(body?.errors || {}).flat()[0] || body?.message || error?.message || 'Please try again.';
};
